module.exports = __webpack_public_path__ + "img/title.dacf0fd1.png";